import type { ReactNode } from "react";

interface FieldProps {
  label: string;
  htmlFor: string;
  required?: boolean;
  children: ReactNode;
}

export function Field({ label, htmlFor, required, children }: FieldProps) {
  return (
    <label className="field" htmlFor={htmlFor}>
      <span className="field-label">
        {label}
        {required ? <span aria-label="required"> *</span> : null}
      </span>
      {children}
    </label>
  );
}
